<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-info m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <!-- <strong class="h4">{{encounters.meta.total}} Encounters</strong> -->
              <strong class="h4">Manage Activities</strong>
            </div>
          </div>
        </div>
      </div>
      <section class="container">
        <div class="col-md-12 mb-5">
          <div class="card">
            <div class="card-header">
              <p class="text-center h4">Filter Parameter</p>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-4">
                  <label>Select Staff </label>
                  <select class="form-control" v-model="filter_field.causer_id">
                    <option :value="employee.id" v-for="employee in employees" :key="employee">
                      {{ employee.full_name }}
                    </option>
                  </select>
                </div>


                <div class="form-group col-md-4">
                  <label>Select Type </label>
                  <select class="form-control" v-model="filter_field.description">
                    <option :value="desc" v-for="desc in descriptions" :key="desc">
                      {{ desc }}
                    </option>
                  </select>
                </div>



                <div class="form-group col-md-4">
                  <label>Model </label>

                  <v-select multiple v-model="filter_field.causer_type" :reduce="name => name.model" label="name"
                    :options="causer_types" />

                </div>

                <div class="form-group col-md-4">
                  <label for="inputCity"><i class="fe fe-calendar"></i> Start Date
                  </label>
                  <input type="date" class="form-control" v-model="filter_field.from" />
                </div>

                <div class="form-group col-md-4">
                  <label for="inputCity"><i class="fe fe-calendar"></i> End Date
                  </label>
                  <input type="date" class="form-control" v-model="filter_field.to" />
                </div>


                <div class="form-group col-md-4">
                  <label>Rows</label>
                  <select class="form-control" v-model="filter_field.per_page">
                    <option value="30">30</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                    <option value="5000">5000</option>
                    <option value="10000">10000</option>
                    <option value="20000">20000</option>
                    <option value="30000">30000</option>
                    <option value="40000">40000</option>
                    <option value="50000">50000</option>
                    <option value="100000">100000</option>
                    <option value="200000">200000</option>
                    <option value="500000">500000</option>
                  </select>
                </div>

                <div class="form-row col-md-12">
                  <button class="btn btn-outline-info btn-block" @click="getActivities('json')">
                    Filter
                  </button>

                  <!-- <button class="btn btn-outline-dark my-2 btn-block">
                    <download-excel :data="activities.data" :fields="json_fields" type="xls" :escapeCsv="false"
                      :name="'activities_data' + '.xls'">
                    </download-excel>
                  </button> -->


                  <button class="btn btn-outline-dark my-2 btn-block" @click="getActivities('excel')">
                    Export to Excel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <div class="row list">
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="table-responsive">
                    <p class="h4 my-3">
                      <span>{{ activities.total }}</span>
                      Activities
                    </p>

                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>User</th>
                          <th>Model</th>
                          <th>Changes</th>

                          <th>Timestamp</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="activity in activities.data" v-bind:key="activity.id">
                          <td>
                            {{ activity.causer.full_name }}
                            <span>
                              <button type="button" class="btn mx-1 badge badge-soft-danger">
                                {{ activity.description }}
                              </button>
                            </span>
                          </td>
                          <td>
                            {{ activity.subject_type ? activity.subject_type.split('\\').pop() : '' }}
                          </td>
                          <td>
                            <button type="button" class="btn m-1 badge badge-soft-dark" v-for="(value, key) in activity.properties
                                .attributes" v-bind:key="key">
                              {{ value }}
                            </button>
                          </td>

                          <td>
                            {{
                            activity.created_at
                            | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin

  import SectorsJson from "@/json/sectors.json";
  // let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        paginate_value: 0,
        employees: "",
        causer_types: [
          { name: "Enrollees", model: "App\\Models\\User" },
          { name: "Dependents", model: "App\\Dependants" },
          { name: "Encounters", model: "App\\Service_summary" },
          { name: "Claim", model: "App\\Claims" },
          { name: "COF", model: "App\\Change_providers" },
          { name: "Payment", model: "App\\Transactions" },
        ],
        descriptions: [
          "created",
          "updated",
          "deleted",
          "restored",
          "User signed in",
          "User signed out",
        ],
        user: null,
        isLoading: false,
        fullPage: true,
        encounterform: false,
        filterparams: false,
        diseases: "",
        providers: "",

        string_data: "",
        lga_states: "",
        sectors: SectorsJson,
        activities: {
          data: [],
        },
        filter_field: {
          format: "json",
          per_page: 30,
          causer_id: "",
          description: "",
          provider_id: "",
          enrollee: "",
          localgovt: "",
          selected_agency: "",
          sector: "",
          date: "",
          from: "",
          to: "",
          is_confirmed: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    methods: {
      getActivities(format) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        const requestFormat = format || "json";
        this.axios
          .post(
            `/api/v1/auth/agency-activities`,
            {
              from: this.filter_field.from,
              to: this.filter_field.to,
              per_page: this.filter_field.per_page,
              causer_type: this.filter_field.causer_type,
              causer_id: this.filter_field.causer_id,
              description: this.filter_field.description,
              agency_id: 95930,
              format: requestFormat,
            },
            requestFormat === "excel"
              ? {
                responseType: "blob",
                timeout: 0,
              }
              : {}
          )
          .then((response) => {

            if (requestFormat === "excel") {
              // If the server sends JSON instead of the file (an error, or a server that
              // doesn't support format=excel yet), show its message instead of saving a broken .xlsx.
              const contentType = String((response.headers && response.headers["content-type"]) || "");
              if (contentType.includes("json")) {
                this.isLoading = false;
                this.isExporting = false;
                response.data.text().then((text) => {
                  let message = "Export failed: the server did not return an Excel file.";
                  try {
                    const body = JSON.parse(text);
                    if (body && body.current_page !== undefined) {
                      message = "Export failed: the server is running an older version that cannot export Excel yet.";
                    } else if (body && body.message) {
                      message = "Export failed: " + body.message;
                    }
                  } catch (e) { /* not JSON */ }
                  console.error("Activities export response:", text.slice(0, 500));
                  this.$toasted.error(message, { position: "top-center", duration: 6000 });
                });
                return;
              }

              const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `activities_${new Date().toISOString().slice(0, 10)}.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);

              this.$toasted.success("Excel file downloaded successfully", {
                position: "top-center",
                duration: 3000,
              });

              this.isLoading = false;
              return;
            }

            this.$toasted.success("Filtered Successfully", {
              position: "top-center",
              duration: 3000,
            });

            this.activities = response.data;
            this.isLoading = false;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
            this.$toasted.error(requestFormat === "excel" ? "Export failed, please try again" : "Unable to load activities", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      getEmployees() {
        this.axios
          .get(`/api/v1/auth/getEmployee/${95930}`)
          .then((response) => {
            this.employees = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.getActivities();
      this.getEmployees();
    },
  };
</script>